<script>
import dayjs from "dayjs";

export default {
    name: "BidRow",
    computed: {
        dayjs() {
            return dayjs
        }
    },
    props: ['bid', 'type', 'currency'],
    filters: {
        toUSD (value) {
            return `$${value.toLocaleString()}`
        }
    }
}
</script>

<template>

    <tr class="font-bold">
        <td class="relative py-5 pr-6">
            <div class="flex gap-x-6 align-middle">
                <i class="pt-1 fa-regular fa-party-horn hidden flex-none text-gray-400 sm:block" v-if="type === 'won'"></i>
                <i class="pt-1 fa-solid fa-face-frown hidden flex-none text-gray-400 sm:block" v-else-if="type === 'lost'"></i>
<!--                <i class="pt-1 fa-solid fa-question hidden flex-none text-gray-400 sm:block" v-else></i>-->
                <div class="flex-auto">
                    <div class="flex items-start gap-x-3">
                        <div class="text-sm leading-6">{{ $filters.formatNumber(bid.bid) }} {{ currency }}</div>
                        <div
                            v-if="type === 'won'"
                            class="rounded-md py-1 px-2 text-xs ring-1 ring-inset text-green-700 bg-green-50 ring-green-600/20">
                            Won</div>
                        <div v-else-if="type === 'lost'"
                            class="rounded-md py-1 px-2 text-xs ring-1 ring-inset text-red-700 bg-red-50 ring-red-600/10">
                            Lost
                        </div>
                        <div v-else
                             class="rounded-md py-1 px-2 text-xs ring-1 ring-inset text-gray-600 bg-gray-50 ring-gray-500/10">
                            In Progress
                        </div>
                    </div>
                </div>
            </div>
            <div class="absolute bottom-0 right-full h-px w-screen bg-gray-100"></div>
            <div class="absolute bottom-0 left-0 h-px w-screen bg-gray-100"></div>
        </td>
        <td class="hidden py-5 pr-6 sm:table-cell">
            <div class="text-sm leading-6">{{ dayjs(bid.created_at) }}</div>
        </td>
    </tr>

<!--        <auction-highest-bid></auction-highest-bid>-->
<!--        <auction-outbid-bid></auction-outbid-bid>-->
<!--        <auction-lost-bid></auction-lost-bid>-->

</template>

<style scoped>

</style>
